export default __webpack_public_path__ + "static/media/img11.2b6afed2.PNG";